export const SET_DATA = 'SET_DATA';
export const DATA_LOADING = 'DATA_LOADING';
export const DATA_ERROR = 'DATA_ERROR';
